import { createMemo, onCleanup, onMount, Show, type JSX } from "solid-js"
import { File } from "./file"
import { getFilePreviewHandler, registerFilePreviewHandler } from "./file-preview-registry"
import { FilePreviewToggle } from "./file-preview-toggle"
import { markdownHandler } from "./file-preview-markdown"
import { htmlHandler } from "./file-preview-html"

registerFilePreviewHandler(markdownHandler)
registerFilePreviewHandler(htmlHandler)

function isSafeExternalUrl(url: string): boolean {
  return /^https?:\/\//i.test(url)
}

export function FilePreviewWrapper(props: Record<string, any>): JSX.Element {
  // The sandboxed HTML preview iframe forwards link clicks / window.open calls
  // to us via postMessage; open them in a new browser tab from the parent.
  onMount(() => {
    const onMessage = (event: MessageEvent) => {
      const data = event.data as { __zdPreviewOpen?: boolean; url?: unknown } | undefined
      if (!data || data.__zdPreviewOpen !== true || typeof data.url !== "string") return
      if (!isSafeExternalUrl(data.url)) return
      window.open(data.url, "_blank", "noopener,noreferrer")
    }
    window.addEventListener("message", onMessage)
    onCleanup(() => window.removeEventListener("message", onMessage))
  })

  if (props.mode === "diff") {
    return <File {...(props as any)} />
  }

  const handler = createMemo(() => getFilePreviewHandler(props.file?.name))

  return (
    <Show when={handler()} fallback={<File {...(props as any)} />}>
      {(h) => (
        <FilePreviewToggle
          handler={h()}
          previewProps={{
            path: props.file?.name ?? "",
            contents: props.file?.contents ?? "",
            cacheKey: props.file?.cacheKey,
            onRendered: props.onRendered,
          }}
          renderSource={() => <File {...(props as any)} />}
        />
      )}
    </Show>
  )
}
